// extracted by mini-css-extract-plugin
export default {"creditItem":"style_creditItem__wN8Rl","redImgCredit":"style_redImgCredit__-3fN2","redCreditImage":"style_redCreditImage__CbVv7","creditInfoTitle":"style_creditInfoTitle__P6SWb"};